<template>
    <div class="video-cont">
        <div class="video">
            <youtube :video-id="youtube.videoId" :player-vars="youtube.options" @ready="ready" @playing="playing"></youtube>
        </div>

        <!--<div class="dark-layer"></div>-->
        <!--<div class="top-0 text-center white position-absolute row h-100 w-100 justify-content-center align-items-center margin-right-left-0">
            <div class="jumbo-info">
                <h1 class="text-uppercase font-lg white">UJV not your typical</h1>
                <h1 class="text-uppercase font-xl white">Wholesaler</h1>
                <hr class="separator-white d-none d-md-block">
                <div class="row justify-content-md-center d-none d-md-flex">
                    <div class="col-md-auto">
                        <img src="/assets/awards/Inc5000.svg" height="110" alt="Inc. 5000"/>
                    </div>
                    <div class="col-md-auto">
                        <img src="/assets/awards/SFBJ.svg" height="110" alt="SFBJ's 2017 Fastest Growing Companies"/>
                    </div>
                </div>
            </div>
        </div>-->

        <div class="controllers-cont">
            <next-section-arrow></next-section-arrow>
            <div class="video-controllers">
                <span v-if="!youtube.playing" @click="play" class="button d-inline-block" id="play-button">
                    <i class="material-icons">play_circle_outline</i>
                </span>
                <span v-if="youtube.playing" @click="pause" class="button d-inline-block" id="pause-button">
                    <i class="material-icons">pause_circle_outline</i>
                </span>
                <span v-if="youtube.muted" @click="unMute" class="button d-inline-block" id="mute-button">
                    <i class="material-icons">volume_off</i>
                </span>
                <span v-if="!youtube.muted" @click="mute" class="button d-inline-block" id="sound-button">
                    <i class="material-icons">volume_up</i>
                </span>
                <span class="d-none d-md-inline-block" id="video-hotel-info">
                    <span class="d-block white"><strong>One&Only Palmilla - Los Cabos</strong></span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import NextSectionArrow from "./../misc/NextSectionArrow";

    let videoId = "9CSZ2-7sZLA";

    export default {
        components: { NextSectionArrow },
        data() {
            return {
                youtube: {
                    player: null,
                    playing: false,
                    muted: false,
                    videoId: videoId,
                    options: {
                        autoplay: 1,
                        controls: 0,
                        loop: 1,
                        playlist: videoId,
                        rel: 0
                    }
                }
            };
        },

        methods: {
            change () {
                // when you change the value, the player will also change.
                // If you would like to change `playerVars`, please change it before you change `videoId`.
                // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
                // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
                this.videoId = 'another video id'
            },
            mute() {
                this.youtube.player.mute();
                this.youtube.muted = true;
            },
            pause() {
                this.youtube.player.pauseVideo();
                this.youtube.playing = false;
            },
            play() { this.youtube.player.playVideo(); },
            playing (event) { this.youtube.playing = true; },
            ready (event) {
                this.youtube.player = event.target;
                this.mute();
            },
            stop() {
                this.youtube.player.stopVideo();
                this.youtube.playing = false;
            },
            unMute() {
                this.youtube.player.unMute();
                this.youtube.muted = false;
            },
        },
    }

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>
